import { Flex } from "@fluentui/react-northstar";
import styled from "styled-components";

export const Wrapper = styled(Flex)``;
